import Tooltip from '@components/common/Tooltip';

const Chart1 = () => {
    return (
        <>
            <div className="card custom-card overflow-hidden">
                <div className="card-header">
                    <div className="card-title">
                        {' '}
                        농작업의사결정
                        <Tooltip
                            content="도움말이 표시될예정"
                            customClass="tooltip-dark"
                            placement="top"
                        >
                            <i className="ri-question-line" />
                        </Tooltip>
                    </div>
                </div>
                <div className="card-body pt-4">
                    <div className="timeline container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="timeline-container">
                                    <div className="timeline-continue pt-0">
                                        <div className="timeline-right">
                                            <div className="timeline-content">
                                                <div className="d-flex gap-2 justify-content-between p-2 bg-light mb-3 flex-wrap rounded align-items-start bg-success-transparent">
                                                    <div className="timeline-end">
                                                        <span className="p-1 fs-11 bg-success text-fixed-white text-center rounded-1 lh-1 fw-medium">
                                                            {' '}
                                                            2025년 4월 27일
                                                        </span>
                                                    </div>
                                                    <p className="timeline-date text-muted mb-0">
                                                        {' '}
                                                        09:45, 목요일{' '}
                                                    </p>
                                                </div>
                                                <div className="timeline-box">
                                                    <p className="text-muted mb-2">
                                                        <span className="text-default">
                                                            <b>
                                                                [비료]추천농작업
                                                            </b>
                                                            <br />
                                                            <br />
                                                            🚨 **긴급 시비
                                                            필요** 🚨
                                                            <br />
                                                            <br />
                                                            ⚠️ **빠른 시일 내
                                                            시비가 필요한
                                                            상태입니다.**
                                                            <br />
                                                            <br />
                                                            📊 현재 상태:
                                                            <br />
                                                            • 질소스트레스: 0.44
                                                            (정상: 0.0 ~ 0.3)
                                                            <br />
                                                            • 인산스트레스: 0.00
                                                            <br />
                                                            • 엽면적지수(LAI):
                                                            0.0
                                                            <br />
                                                            • 생육일수(DAP):
                                                            12일
                                                            <br />
                                                            <br />
                                                            💧 **권장 조치:**
                                                            <br />
                                                            • 질소(N): **15.0
                                                            kg/ha**
                                                            <br />
                                                            • 인산(P₂O₅): **5.0
                                                            kg/ha**
                                                            <br />
                                                            • 칼리(K₂O): **8.0
                                                            kg/ha**
                                                            <br />
                                                            • 실행시기:
                                                            **내일까지**
                                                            <br />
                                                            <br />
                                                            🔔 추가 안내:
                                                            <br />
                                                            • 엽면시비를
                                                            권장합니다 (빠른
                                                            흡수)
                                                            <br />
                                                            • 시비 후 작물
                                                            반응을
                                                            모니터링하세요
                                                            <br />
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="timeline-right">
                                            <div className="timeline-content">
                                                <div className="d-flex gap-2 justify-content-between p-2 bg-light mb-3 flex-wrap rounded align-items-start bg-info-transparent">
                                                    <div className="timeline-end">
                                                        <span className="p-1 fs-11 bg-info text-fixed-white text-center rounded-1 lh-1 fw-medium">
                                                            {' '}
                                                            2025년 4월 27일
                                                        </span>
                                                    </div>
                                                    <p className="timeline-date text-muted mb-0">
                                                        {' '}
                                                        09:45, 목요일{' '}
                                                    </p>
                                                </div>
                                                <div className="timeline-box">
                                                    <p className="text-muted mb-2">
                                                        <span className="text-default">
                                                            <b>
                                                                [관수]추천농작업
                                                            </b>
                                                            <br />
                                                            <br />
                                                            💧 현재 수분 부족
                                                            상태입니다 (스트레스
                                                            지수: 0.97).
                                                            <br />
                                                            <br />
                                                            향후 5일간 비 예보가
                                                            부족하여 (0.0mm)
                                                            **2일 후 10.0mm
                                                            관수를 권장**합니다.
                                                            <br />
                                                            <br />
                                                            📊 이 값은 다중
                                                            실험(수확량: 605
                                                            kg/ha, 물이용효율:
                                                            4.8)에서 최적으로
                                                            도출된 결과입니다.
                                                            <br />
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="timeline-right">
                                            <div className="timeline-content">
                                                <div className="d-flex gap-2 justify-content-between p-2 bg-light mb-3 flex-wrap rounded align-items-start bg-secondary-transparent">
                                                    <div className="timeline-end">
                                                        <span className="p-1 fs-11 bg-secondary text-fixed-white text-center rounded-1 lh-1 fw-medium">
                                                            {' '}
                                                            2025년 4월 27일
                                                        </span>
                                                    </div>
                                                    <p className="timeline-date text-muted mb-0">
                                                        {' '}
                                                        09:45, 목요일{' '}
                                                    </p>
                                                </div>
                                                <div className="timeline-box">
                                                    <p className="text-muted mb-2">
                                                        <span className="text-default">
                                                            <b>
                                                                [병충해]추천농작업
                                                            </b>
                                                            <br />
                                                            <br />
                                                            🌱 생육단계별 방제가
                                                            필요합니다 (DAP:
                                                            58일).
                                                            <br />
                                                            <br />
                                                            💊 **권장 방제:**
                                                            <br />
                                                            • 농약: **제초제**
                                                            <br />
                                                            • 처리량: **2.0
                                                            kg/ha**
                                                            <br />
                                                            • 방법: **토양처리**
                                                            <br />
                                                            • 권장시기: **15일
                                                            후**
                                                            <br />
                                                            <br />
                                                            📊 실험 데이터 기반:
                                                            처리구 1에서 DAP
                                                            30일에 살포하여 131
                                                            kg/ha 수확
                                                            <br />
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="timeline-right">
                                            <div className="timeline-content">
                                                <div className="d-flex gap-2 justify-content-between p-2 bg-light mb-3 flex-wrap rounded align-items-start bg-primary-transparent">
                                                    <div className="timeline-end">
                                                        <span className="p-1 fs-11 bg-primary text-fixed-white text-center rounded-1 lh-1 fw-medium">
                                                            {' '}
                                                            2025년 4월 27일
                                                        </span>
                                                    </div>
                                                    <p className="timeline-date text-muted mb-0">
                                                        {' '}
                                                        09:45, 목요일{' '}
                                                    </p>
                                                </div>
                                                <div className="timeline-box">
                                                    <p className="text-muted mb-2">
                                                        <span className="text-default">
                                                            <b>
                                                                [잔재물]추천농작업
                                                            </b>
                                                            <br />
                                                            <br />
                                                            🌾 **수확 후 잔재물
                                                            관리 추천**
                                                            <br />
                                                            <br />
                                                            수확이
                                                            완료되었습니다. 다음
                                                            재배를 위한 잔재물
                                                            처리가 필요합니다.
                                                            <br />
                                                            <br />
                                                            💧 **권장 조치:**
                                                            <br />
                                                            • 잔재물량: **500
                                                            kg/ha**
                                                            <br />
                                                            • 처리방법:
                                                            **토양혼입(혼합)**
                                                            <br />
                                                            • 혼합깊이: **10
                                                            cm**
                                                            <br />
                                                            <br />
                                                            📊 이 값은 다중
                                                            실험에서 다음 작기
                                                            수확량(2856 kg/ha)과
                                                            경제성을 고려한 최적
                                                            조건입니다.
                                                            <br />
                                                            <br />
                                                            🔔 추가 안내:
                                                            <br />
                                                            • 잔재물 처리 후
                                                            충분한 분해
                                                            기간(2-3주)을
                                                            확보하세요
                                                            <br />
                                                            • 과도한 잔재물은
                                                            병해충 발생 위험이
                                                            있습니다
                                                            <br />
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="timeline-right">
                                            <div className="timeline-content">
                                                <div className="d-flex gap-2 justify-content-between p-2 bg-light mb-3 flex-wrap rounded align-items-start bg-pink-transparent">
                                                    <div className="timeline-end">
                                                        <span className="p-1 fs-11 bg-pink text-fixed-white text-center rounded-1 lh-1 fw-medium">
                                                            {' '}
                                                            2025년 4월 27일
                                                        </span>
                                                    </div>
                                                    <p className="timeline-date text-muted mb-0">
                                                        {' '}
                                                        09:45, 목요일{' '}
                                                    </p>
                                                </div>
                                                <div className="timeline-box">
                                                    <p className="text-muted mb-2">
                                                        <span className="text-default">
                                                            <b>
                                                                [경운]추천농작업
                                                            </b>
                                                            <br />
                                                            <br />
                                                            🚜 **수확 후 토양
                                                            관리 추천**
                                                            <br />
                                                            <br />
                                                            작물 수확이
                                                            완료되었습니다. 현재
                                                            토양 상태 분석 결과
                                                            다음 조치가
                                                            필요합니다.
                                                            <br />
                                                            <br />
                                                            📊 **현재 토양
                                                            상태:**
                                                            <br />
                                                            • 잔재물 수준:
                                                            **적음 (바이오매스
                                                            4톤/ha 미만)**
                                                            <br />
                                                            • 토양 다짐: **심함
                                                            (뿌리 발달 제한)**
                                                            <br />
                                                            • 토양 수분:
                                                            **적정**
                                                            <br />
                                                            <br />
                                                            💡 **권장 조치:**
                                                            <br />
                                                            • 경운 기구:
                                                            **심경기(Subsoiling)**
                                                            <br />
                                                            • 경운 깊이: **25
                                                            cm**
                                                            <br />
                                                            • 목적: 심층 토양
                                                            파쇄, 배수 개선
                                                            <br />
                                                            • 실행 시기:
                                                            **2025-09-28 (수확
                                                            후 7일)**
                                                            <br />
                                                            <br />
                                                            🎯 **개선 효과:**
                                                            <br />
                                                            • 심층 토양 다짐
                                                            해소로 뿌리 생장
                                                            환경 개선
                                                            <br />
                                                            • 토양 구조 개선 및
                                                            미생물 활성 증진
                                                            <br />
                                                            • 다음 작기 작물
                                                            생육 환경 최적화
                                                            <br />
                                                            <br />
                                                            <br />
                                                            🔔 **주의사항:**
                                                            <br />
                                                            • 토양이 너무
                                                            습하거나 건조하지
                                                            않을 때 실시하세요
                                                            <br />
                                                            • 경운 후 2-3주
                                                            휴식기를 두고 다음
                                                            작물을 파종하세요
                                                            <br />
                                                            • 과도한 경운은 토양
                                                            구조를 파괴할 수
                                                            있습니다
                                                            <br />
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Chart1;
